// extracted by mini-css-extract-plugin
module.exports = {"container":"base-price-text_container__w46W0","price-part":"base-price-text_price-part__UR2cy","original-price":"base-price-text_original-price__7QNtr"};